import { useState } from "react";

export const useQuantity = (
  initialValue: number
): [number, () => void, () => void, (number: number) => void] => {
  const [quantity, setQuantity] = useState(initialValue);

  const decreaseQuantity = async (asyncFunc: Function = () => {}) => {
    if (quantity > 1) {
      const newValue = quantity - 1;
      await asyncFunc(newValue);
      setQuantity(newValue);
    }
  };

  const increaseQuantity = async (asyncFunc: Function = () => {}) => {
    if (quantity < 100) {
      const newValue = quantity + 1;
      await asyncFunc(newValue);
      setQuantity(newValue);
    }
  };

  const resetQuantity = (number: number = 1) => {
    setQuantity(number);
  };

  return [quantity, decreaseQuantity, increaseQuantity, resetQuantity];
};
